module.exports = __webpack_public_path__ + "static/media/parachute-box.fefd3e05.svg";